/**
 * 화면에 본문을 보여줄 번역본. 저작권 표시(성명표시권)에 쓰는 문구가 여기 있다.
 *
 * 본문 표시는 대한성서공회 사용 허가가 확정되기 전이라 개발용이다 — 실제 본문은
 * bible_verses 테이블에 데이터가 있을 때만 나오고, 없으면 화면이 자리표시로 대체한다.
 * 번역본이 바뀌면(예: 개역한글) id/name만 고치면 된다. CLAUDE.md 미결정 사항 참고.
 */
export const DISPLAY_TRANSLATION = {
  /** bible_verses.translation 값 */
  id: "개역개정",
  name: "성경전서 개역개정판",
  copyright: "대한성서공회",
} as const;
